function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "VixEuL.tif"
}, React.createElement("g", null, React.createElement("path", {
  d: "M86.1,150c-10.5,0-20.8,0-31.2,0c0-24.9,0-49.7,0-74.7c-5,0-9.7,0-14.7,0c0-9,0-17.7,0-26.6c4.1,0,8,0,11.9,0 c2.7,0,2.7,0,2.7-2.8c0.1-6.1-0.2-12.2,0.3-18.2c0.8-9.1,4.2-17,12-22.4C73,1.2,79.8,0.1,86.7,0c6.9-0.1,13.8,0.1,20.8,0.1 c1,0,1.9-0.1,1.9,1.5c-0.1,7.8-0.1,15.7-0.1,23.5c0,0.1-0.1,0.3-0.3,0.7c-1.5,0-3.2,0-4.9,0c-4.1,0-8.2,0-12.3,0.2 c-3.4,0.2-5.5,2-5.6,5.2c-0.3,5.7-0.1,11.4-0.1,17.3c7.8,0,15.5,0,23.6,0c-0.9,8.9-1.8,17.6-2.7,26.5c-7,0-13.9,0-21,0"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      "enableBackground": "new 0 0 150 150"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/facebook.5af34745.svg";
export { SvgComponent as ReactComponent };